export default async <T, B>(
  url: string,
  options: {
    method?: 'GET' | 'POST';
    body?: B;
    headers?: any;
    timeout?: number;
  } = {}
): Promise<T | { error: string }> => {
  const {
    method = 'GET',
    body,
    headers = {},
    timeout = 60000, // 1 minute timeout
  } = options;
  const controller = new AbortController();
  const hdrs = {
    'Content-type': 'application/json',
    ...headers,
  };
  const requestInit: RequestInit = {
    method: method.toUpperCase(),
    signal: controller.signal,
    // eslint-disable-next-line id-blacklist
    body: typeof body === 'object' ? JSON.stringify(body) : undefined,
    mode: 'cors',
    headers: hdrs,
  };

  setTimeout(() => controller.abort(), timeout);
  try {
    const res = await fetch(`${url}`, requestInit);
    if (!res.ok) {
      const text = await res.text();
      return { error: `${res.status} - ${text}` };
    }
    const text = await res.text();
    if (text.length === 0) { throw "empty result"; }
    return JSON.parse(text)
  } catch (err) {
    return { error: `${err}` };
  } finally {
    controller.abort();
  }
};
